import { render, staticRenderFns } from "./ship.vue?vue&type=template&id=429a6fa8&scoped=true&"
import script from "./ship.vue?vue&type=script&lang=ts&"
export * from "./ship.vue?vue&type=script&lang=ts&"
import style0 from "./ship.vue?vue&type=style&index=0&id=429a6fa8&scoped=true&lang=stylus&"
import style1 from "./ship.vue?vue&type=style&index=1&id=429a6fa8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429a6fa8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/project/xunjie/ams_old/ams-admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDatePicker } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSubheader } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
import { VTimeline } from 'vuetify/lib'
import { VTimelineItem } from 'vuetify/lib'
installComponents(component, {VBtn,VCardText,VDataTable,VDatePicker,VDialog,VFlex,VForm,VIcon,VLayout,VList,VListTile,VListTileTitle,VMenu,VSelect,VSubheader,VTextField,VTextarea,VTimeline,VTimelineItem})
